import React from 'react';
import PropTypes from 'prop-types';

import DataList from '../DataList';
import { TABS_PATIENT_PORTAL } from '../../constants';
import MedicationsList from '../DataList/MedicationsList';
import HealthRecordsList from '../DataList/HealthRecordsList';

const { HEALTH_RECORD, MEDICATIONS } = TABS_PATIENT_PORTAL;

const DataListWrapper = ({ activeTab, ...data }) => {
  const props = { ...data, activeTab };
  switch (activeTab) {
    case HEALTH_RECORD:
      return <HealthRecordsList {...props} />;
    case MEDICATIONS:
      return <MedicationsList {...props} />;
    default:
      return <DataList {...props} />;
  }
};

DataListWrapper.propTypes = {
  activeTab: PropTypes.string,
};

export default DataListWrapper;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataListWrapper/index.jsx